<template>
  <div>
    <div class="top" @click="showTableHander">
      <div class="top_div">
        <div class="circleYellow"></div>
        <div class="cost_title">{{$t('expense.cost')}}</div>
        <div class="total_amout">{{$t('expense.total')}}:{{total}}{{$t('expense.costUnit')}}</div>
      </div>
      <div style="width: 40px;cursor: pointer;text-align: right">
        <a-icon type="caret-up" style="color:#cacaca;font-size: 12px;" v-show="showTable"/>
        <a-icon type="caret-down" style="color:#cacaca;font-size: 12px;" v-show="!showTable" />
      </div>
    </div>
    <div v-show="showTable" class="table_div">
      <pt-simple-table @sort-change="sortChange" :sort-v-o="sortVo" :loading="false" :data-source="list" :show-add="false" :total="0">
        <template slot="columns">
<!--          <el-table-column align="left" prop="number" show-overflow-tooltip :label="$t('expense.costTable.expenseId')">-->
<!--            <template slot-scope="scope">-->
<!--              <span>{{scope.row.number}}</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column align="left" prop="type" :label="$t('expense.costTable.type')">
            <template slot-scope="scope">
              {{typeMap[scope.row.type]}}
            </template>
          </el-table-column>
          <el-table-column align="left" sortable="custom" prop="create_time" width="120" :label="$t('expense.costTable.date')">
            <template slot-scope="scope">
              {{scope.row.createTime}}
            </template>
          </el-table-column>
          <el-table-column align="left" sortable="custom" prop="amount" :label="$t('expense.costTable.amount')"></el-table-column>
          <el-table-column align="left" prop="userName" width="120" show-overflow-tooltip :label="$t('expense.costTable.applyUser')"></el-table-column>
          <el-table-column align="left" prop="remarks"  show-overflow-tooltip :label="$t('expense.costTable.remarks')"></el-table-column>
        </template>
      </pt-simple-table>
    </div>
  </div>
</template>

<script>
import Api from '@/api/mine/expense'
import { getDatadictChildsByPath } from '@/api/sys/datadict'
export default {
  name: 'expenseCost',
  props:{
    businessType:{
      type: [String, Number],
      default:2,
    },
    busienssId:{
      type:String,
      default:null,
    }
  },
  data(){
    return {
      list:[],
      types:[],
      total:0,
      showTable:false,
      sortVo:{
        orderColumn:'create_time',
        orderValue:'desc',
      }

    }
  },
  computed:{
    typeMap() {
      let arr = []
      this.types.forEach(item => {
        arr[item.wordKey] = item.wordValue
      })
      return arr
    },
  },
  mounted() {
    this.initTypes();
    this.initData();
  },
  methods:{
    sortChange(orderColumn,orderValue){
      this.sortVo.orderColumn = orderColumn
      this.sortVo.orderValue = orderValue
      this.initData();
    },
    initTypes() {
      getDatadictChildsByPath('system.expense.type').then(res => {
        this.types = res.data
      })
    },
    showTableHander(){
      if(this.list.length > 0){
        this.showTable = !this.showTable;
      }
    },
    initData(){
      Api.selectExpenseCost(this.businessType,this.busienssId,this.sortVo).then(res=>{
        if(res.code == 1){
          this.list =res.data.data;
          this.total = res.data.total;
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.top{
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #FAFBFC;
  height: 40px;
  padding-right:  20px;
  margin-top: 10px;
  margin-bottom: 5px;
  .top_div{
    display: flex;
    align-items: center;
    .circleYellow{
      width: 12px;
      height: 12px;
      background: #FABE00;
      border-radius: 50%;
      margin: 0 10px;
    }
    .cost_title{
      font-size: 14px;
      color: #333333;
      letter-spacing: 0;
      font-weight: 600;
    }
    .total_amout{
      margin-left: 128px;
      font-size: 14px;
      color: #333333;
      letter-spacing: 0;
      font-weight: 600;
    }
  }

}
.table_div{
  background: #FAFBFC;
  padding: 0px 16px 11px;
  /deep/ .el-table{
    background: transparent;
    td{
      background: transparent !important;
    }
    tr{
      background: transparent !important;
    }
    tr:last-child td{
      border: 0px !important;
    }
  }
  ///deep/ .el-table::before{
  //  height: 0px !important;
  //}
}
</style>